module.exports = __webpack_public_path__ + "f95662d8ebda4423fb00036525991e3b.ttf";